
import React from 'react';
import { motion } from 'framer-motion';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
import { fadeInUp, staggerContainer, staggerItem } from '../../utils/animations';
import './ConsultingAreas.css';

const ConsultingAreas = () => {
    const [ref, isVisible] = useIntersectionObserver();

    const areas = [
        {
            title: "Organizational Diagnosis & Transformation",
            desc: "Understanding and strengthening organizational health"
        },
        {
            title: "Strategy to Execution Consulting",
            desc: "Bridging intent, systems, and outcomes"
        },
        {
            title: "Leadership & Capability Enablement",
            desc: "Building leadership alignment and execution capability"
        },
        {
            title: "Process, System & Digital Enablement",
            desc: "Designing scalable processes supported by the right systems"
        }
    ];

    return (
        <section className="consulting-areas-section section" ref={ref}>
            <div className="container">
                <motion.div
                    className="consulting-header"
                    initial="initial"
                    animate={isVisible ? "animate" : "initial"}
                    variants={fadeInUp}
                >
                    <h3 className="consulting-title">Our Core Consulting Areas</h3>
                    <h4 className="consulting-subtitle">Where organizations typically engage us</h4>
                </motion.div>

                <motion.div
                    className="consulting-grid"
                    variants={staggerContainer}
                    initial="initial"
                    animate={isVisible ? "animate" : "initial"}
                >
                    {areas.map((area, index) => (
                        <motion.div key={index} className="consulting-card" variants={staggerItem}>
                            <div className="consulting-card-content">
                                <h4 className="consulting-card-title">{area.title}</h4>
                                <p className="consulting-card-desc">{area.desc}</p>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>

                <motion.div
                    className="consulting-footer"
                    initial={{ opacity: 0 }}
                    animate={isVisible ? { opacity: 1 } : {}}
                    transition={{ delay: 0.5 }}
                >
                    <p>Each engagement is <span className="highlight">custom-designed</span>, not template-driven.</p>
                </motion.div>
            </div>
        </section>
    );
};

export default ConsultingAreas;
